import { PayloadAction } from '@reduxjs/toolkit';
import {
  BroadcastError,
  Campaign,
  ExcelAuditResult,
  validateExcelFilePOST,
} from '@services/whatsappBroadcast.service';
import { call, put, takeLeading } from 'redux-saga/effects';
import {
  fetchingValidateExcel,
  fetchValidateExcel,
  fetchValidateExcelFailure,
  fetchValidateExcelSuccess,
} from '../reducers/whatsAppValidateExcel.reducer';

function* fetchValidateExcelSaga(
  action: PayloadAction<Partial<Campaign> & { auditId?: string }>
) {
  try {
    yield put(fetchingValidateExcel());

    const result: ExcelAuditResult | BroadcastError = yield call(
      validateExcelFilePOST,
      action.payload
    );

    // Check if result contains an error
    if ('errorCode' in result) {
      yield put(fetchValidateExcelFailure(result as BroadcastError));
    } else {
      yield put(fetchValidateExcelSuccess(result as ExcelAuditResult));
    }
  } catch (error) {
    yield put(
      fetchValidateExcelFailure({
        details: 'Failed to validate Excel file',
        errorCode: 'OPERATION_FAILED',
        timestamp: Date.now(),
        traceId: 'unknown',
      })
    );
  }
}

export default function* whatsAppValidateExcelSaga() {
  yield takeLeading(fetchValidateExcel.type, fetchValidateExcelSaga);
}
